import api from './api';

export interface Organization {
  uuid: string;
  name: string;
}

export const organizationsService = {
  getCurrent: async (): Promise<Organization> => {
    const response = await api.get<Organization>('/api/organizations/me/');
    return response.data;
  },
};